import { SecondaryButton } from '@/app/components/SecondaryButton'
import { ICourse } from '@/types/course'
import { useTranslations } from 'next-intl'

type LearningDescriptionProps = {
  courseInfo: Pick<ICourse, 'learningDescription' | 'brochureUrl'>
} & React.HTMLAttributes<HTMLDivElement>

export function LearningDescription({
  courseInfo,
  ...props
}: LearningDescriptionProps) {
  const t = useTranslations('CoursePage')

  if (!courseInfo.learningDescription) {
    return null
  }

  return (
    <div {...props} className={`${props.className}`}>
      <h2 className="font-title text-sm font-normal uppercase leading-6 text-gray-light">
        {t('overview')}
      </h2>
      {/** TODO: add read more component */}
      <p className="mt-4 text-sm leading-6 text-mydra-black md:mt-2 md:text-justify md:text-base lg:mt-4">
        {courseInfo.learningDescription}
      </p>
      {courseInfo?.brochureUrl && (
        <SecondaryButton
          className="mt-6 block w-fit font-medium md:mt-8"
          href={courseInfo.brochureUrl}
          variant="gray"
          type="button"
          download
          target="_blank"
        >
          {t('view_brochure')}
        </SecondaryButton>
      )}
    </div>
  )
}
